import React from 'react';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';

import { WorkflowViewDiagram, type Props } from './WorkflowViewDiagram.tsx';

const WorkflowViewDiagramApp = (props: Props): React.JSX.Element => {
	return (
		<ContextualAnalyticsData sourceName="workflowViewDiagram" sourceType={SCREEN}>
			<WorkflowViewDiagram {...props} />
		</ContextualAnalyticsData>
	);
};

export default WorkflowViewDiagramApp;
